import React from "react";

function PaymentsPlaceholder() {
  return (
    <div style={{ padding: "48px 24px", textAlign: "center" }}>
      <h2>Payments</h2>
      <p style={{ color: "#666", marginTop: 8 }}>Coming soon.</p>
    </div>
  );
}

export default PaymentsPlaceholder;
